import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Checks if there's an active cash session.
 * Shows a toast error and returns false if no session is open.
 * Returns true if a session is active.
 */
export async function requireCashSession() {
  try {
    const response = await axios.get(`${API}/cash/sessions/active`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    // Endpoint returns null or session object
    if (response.data && response.data.id) return true;
    toast.error("No hay caja abierta. Abre la caja antes de realizar operaciones con cobro.");
    return false;
  } catch {
    toast.error("No hay caja abierta. Abre la caja antes de realizar operaciones con cobro.");
    return false;
  }
}
